export const en = {
  about: "About",
  email: "Email",
  license: "License",
}
